import { render } from "./HomeAsk.vue?vue&type=template&id=72907451"
import script from "./HomeAsk.vue?vue&type=script&lang=js"
export * from "./HomeAsk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__